import service from '../utils/request';
// let stationCode = sessionStorage.getItem('STATION_CODE');
// console.log(stationCode,'工作站编码')
let stationCode = 'SMZRAZDA';

export function addOpportunity(data) {
    return service({
        url: '/sys/opportunity/add',
        method: 'post',
        data
    })
}
export function getOpportunity(params) {
    return service({
        url: '/sys/opportunity/list',
        method: 'get',
        params
    })
}

export function getCopyrightMedia(params){
    return service({
        url: '/copyright/copyrightMediate/infoNoAuth/',
        method: 'get',
        params
    })
}

export function getCopyrightStudy(params){
    return service({
        url: '/copyright/copyrightLearn/listNoAuth',
        method: 'get',
        params
    })
}
export function getCopyrightActive(params){
    return service({
        url: '/copyright/copyrightActivity/listNoAuthAll',
        method: 'get',
        params
    })
}
export function getCopyrightActiveInfo(params){
    return service({
        url: '/copyright/copyrightActivity/infoNoAuth',
        method: 'get',
        params
    })
}
export function getCopyrightRegister(params){
    return service({
        url: '/copyright/copyrightRegister/listNoAuth',
        method: 'get',
        params
    })
}
export function getCopyrightRegisterCers(params){
    return service({
        url: '/copyright/copyrightRegister/getCersNoAuth',
        method: 'get',
        params
    })
}
export function getCopyrightIntroduce(params){
    return service({
        url: '/copyright/copyrightIntroduce/infoNoAuth/SMZRAZDA',
        method: 'get',
        params
    })
}
export function getOffLineDelivery(params){
    return service({
        url: '/copyright/offlineFastHandle/infoNoAuth/SMZRAZDA',
        method: 'get',
        params
    })
}
export function getWorkList(params){
    return service({
        url: '/copyright/works/listNoAuth',
        method: 'get',
        params
    })
}

export function checkWork(params){
    return service({
        url: '/copyright/works/getCersAuth',
        method: 'get',
        params
    })
}